<template>
    <div>

<!--        {{location}}: {{host}}-->

        <div v-if="showLoadTimes && axiosData.length > 0">
            <div class="alert alert-info mb-4">
                <h5>{{$t('text.documentDetails.loadingTime')}}</h5>
                <ol>
                    <li v-for="item in axiosData"><small>{{item.url}} - <div class="badge badge-info"><i class="fa fa-clock"></i> {{item.time}} {{$t('text.documentDetails.milliseconds')}}</div></small></li>
                </ol>
            </div>
        </div>

        <div class="row" v-if="Object.keys(nodeData).length > 0">

            <div class="col-md-12">

                <h2 class="preventLongStringOutbreak">
                    <i v-if="!deleted" :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"></i>
                    {{nodeData.properties["cm:title"]}} <span class="badge badge-warning" v-if="nodeOriginalData.properties['EH:status_gradiva'] === 3 && !deleted">{{$t('text.documentDetails.documentArchived')}}</span>
                    <span class="badge badge-danger" v-if="deleted">{{$t('text.documentDetails.documentDeleted')}}</span>
                </h2>
                <h6>
                    <b>{{$t('text.metadata.originalName')}}: {{nodeData.properties["rma:origionalName"] ? nodeData.properties["rma:origionalName"] : '/'}}</b>
                </h6>
                <p class="mb-3">
                    <small><i class="fa fa-calendar text-black-50"></i> {{moment(nodeData.modifiedAt).utc().format("DD. MM. YYYY HH:mm:ss")}} <span
                                class="text-black-50">|</span> <i class="fa fa-user text-black-50"></i>
                        {{nodeData.modifiedByUser ? nodeData.modifiedByUser.displayName : ''}}</small>
                </p>
            </div>

        </div>
        <div class="row">

            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="false"></loading>

            <div class="col-md-8 mb-5">

                <div>

                    <DocumentDetailsPreview
                            v-if="Object.keys(nodeData).length > 0"
                            :nodeOriginalData="nodeOriginalData"
                            :nodeData="nodeData"
                            :getPreviewIframeContent="getPreviewIframeContent"
                            :deleted="deleted"
                            :isLoadingPreview="isLoadingPreview"
                            :numPages="numPages"
                    ></DocumentDetailsPreview>

                </div>
            </div>

            <div class="col-md-4 mb-5">
                <div class="row">
                    <div>
                        <DocumentDetailsMetadata
                                v-if="nodeData && Object.keys(nodeData).length > 0"
                                :nodeOriginalData="nodeOriginalData"
                                :nodeData="nodeData"
                                :components="components"
                                :linksToLeadingDocument="linksToLeadingDocument"
                                :linksToParentDocument="linksToParentDocument"
                                :linksToParentDocumentComponents="linksToParentDocumentComponents"
                                :deleted="deleted"
                                :longStorageDocumentIsAvailable="longStorageDocumentIsAvailable"
                                :podpisi="podpisi"
                                :file-blob="fileBlob"
                        ></DocumentDetailsMetadata>

                    </div>
                </div>
            </div>


        </div>

        <b-modal ref="deleteArchivedRecord-modal" :title="$t('text.documentDetails.archivedDocumentDeletionModal.title')" size="lg">

            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="false"></loading>

            <div class="row mb-5">
                <div class="col-md-12 mb-0">

                    <p>{{$t('text.documentDetails.archivedDocumentDeletionModal.prompt1')}}<b>{{nodeData.properties ? nodeData.properties["cm:title"] : ''}}</b>{{$t('text.documentDetails.archivedDocumentDeletionModal.prompt2')}}</p>


                    <div class="form-group">
                        <label for="reassignComment">{{$t('text.globals.comment')}}</label>
                        <textarea class="form-control" id="reassignComment"
                                  name="aspectDescription"
                                  rows="5"
                                  v-model="deleteArchivedRecordDescription"
                        ></textarea>
                    </div>

                </div>

            </div>

            <div slot="modal-footer" class="w-100">
                <b-button
                        id="deleteArchivedRecordBtn"
                        variant="danger"
                        class="float-right"
                        @click="deleteArchivedRecord()">
                    <i class="fa fa-trash"></i> {{$t('text.globals.delete')}}
                </b-button>

                <b-button
                        id="closeDeleteArchivedModal"
                        variant="default"
                        class="float-right"
                        @click="closeModal()">
                    {{$t('text.globals.cancel')}}
                </b-button>
            </div>

        </b-modal>

        <b-modal ref="changeStorageLocation-modal" :title="$t('text.documentDetails.archivedDocumentStorageLocationEditModal.title')" size="lg">

            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="false"></loading>

            <div class="row">
                <div class="col-md-12 mb-2">

                    <div class="alert alert-danger" v-if="showChangeStorageLocationValidation">
                        <i class="fa fa-exclamation-triangle d-inline-block mr-3"></i> {{$t('text.documentDetails.archivedDocumentStorageLocationEditModal.allFieldsRequired')}}
                    </div>

                    <div class="form-group">
                        <label for="changeStorageLocationSendDate">{{$t('text.documentDetails.archivedDocumentStorageLocationEditModal.sendDate')}}</label>
                        <VueCtkDateTimePicker
                                :noLabel="true"
                                :id="changeStorageLocationSendDate"
                                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                formatted="DD.MM.YYYY, HH:mm"
                                v-model="changeStorageLocationSendDate"
                                :locale="$t('text.globals.datePickerLocale')"
                                :button-now-translation="$t('text.globals.now')"
                        />
                    </div>

                    <div class="form-group">
                        <label for="changeStorageLocationReceieveDate">{{$t('text.documentDetails.archivedDocumentStorageLocationEditModal.receivedDate')}}</label>
                        <VueCtkDateTimePicker
                                :noLabel="true"
                                :id="changeStorageLocationReceieveDate"
                                format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                formatted="DD.MM.YYYY, HH:mm"
                                v-model="changeStorageLocationReceieveDate"
                                :locale="$t('text.globals.datePickerLocale')"
                                :button-now-translation="$t('text.globals.now')"
                        />
                    </div>

                    <div class="form-group">
                        <label for="changeStorageLocationNewLocation">{{$t('text.documentDetails.archivedDocumentStorageLocationEditModal.newLocation')}}</label>
                        <input type="text"
                               :id="changeStorageLocationNewLocation"
                               class="form-control"
                               v-model="changeStorageLocationNewLocation"/>
                    </div>
                </div>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-button
                        id="changeStorageLocationBtn"
                        variant="primary"
                        class="float-right"
                        @click="changeStorageLocation()">
                    <i class="fa fa-save"></i> {{$t('text.globals.save')}}
                </b-button>

                <b-button
                        id="closeChangeStorageLocationModal"
                        variant="default"
                        class="float-right"
                        @click="closeModal()">
                    {{$t('text.globals.cancel')}}
                </b-button>
            </div>

        </b-modal>

    </div>

</template>


<script>
    import Vue from 'vue';
    import pdf from 'vue-pdf'
    import DocumentDetailsMetadata from '../components/DocumentDetailsMetadata';
    import DocumentDetailsPreview from '../components/DocumentDetailsPreview';
    import Loading from "vue-loading-overlay";
    import vSelect from "vue-select";
    import axios from "axios";

    export default {
        name: 'DocumentDetailsComponent',
        props: [
            "fileId",
            "showLoadTimes",
            "location",
            "host"
        ],
        components: {
            Vue,
            DocumentDetailsMetadata,
            DocumentDetailsPreview,
            Loading,
            pdf
        },
        data() {
            return {
                axiosData: [],
                deleted: false,
                page: 1,
                numPages: 0,
                rotate: 0,
                sites: [],
                user: {},
                error: '',
                nodeOriginalData: {},
                nodeData: {},
                podpisi: [],
                isLoading: true,
                isLoadingPreview: false,
                fileBlob: null,
                filePreviewBlob: null,
                renditionRequests: 0,
                allMetadataOptions: [],
                components: [],
                linksToLeadingDocument: [],
                linksToParentDocument: [],
                linksToParentDocumentComponents: [],

                deleteArchivedRecordDescription: '',
                mestoHrambeOptions: [],
                changeStorageLocationNewLocation: '',
                changeStorageLocationSendDate: null,
                changeStorageLocationReceieveDate: null,
                showChangeStorageLocationValidation: false,
                longStorageDocumentIsAvailable: false
            };
        },
        watch: {
            'fileId': function(){
                this.getNode(this.fileId);
            }
        },
        mounted() {
            const _this = this;

            let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
            let p2 = _this.$store.dispatch("retrieveAllMetadataOptions");
            let p3 = _this.$store.dispatch("retrieveCodeListProperties");

            Promise.all([p1, p2, p3]).then(async (values) => {
              _this.allMetadataOptions = await _this.$store.getters.getAllMetadataOptions;

              if (_this.fileId) {
                _this.getNode(_this.fileId);
              }
            });

        },

        computed: {

            getPreviewIframeContent() {
                const _this = this;

                if (_this.filePreviewBlob !== null) {

                    if(_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'image' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'video' && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'audio'  && _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) !== 'html') {
                        pdf.createLoadingTask(window.URL.createObjectURL(_this.filePreviewBlob)).then(pdf => {
                            _this.numPages = pdf.numPages;
                        });
                    }

                    return window.URL.createObjectURL(_this.filePreviewBlob);
                }
            },


        },

        methods: {

            goToDocument(id) {
                this.$router.push({ name: 'DocumentDetails', params: { id: id} });
            },

            async getNode(nodeId) {
                const _this = this;

                _this.axiosData = [];

                let requestUrl = null;
                if(_this.location === 'cache') {
                    requestUrl = _this.host + config.cacheCoreApi + 'nodes/';
                } else {
                    requestUrl = config.alfrescoCoreApi + 'nodes/';
                }

                await axios.get(requestUrl + nodeId)
                    .then((res) => {


                        if(this.showLoadTimes) {
                            _this.axiosData.push({
                                url: res.url,
                                time: res.responseTime
                            });
                        }

                        _this.nodeOriginalData = res.data.entry;
                        _this.nodeData = _this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, _.cloneDeep(res.data.entry));

                        _this.deleted = _this.nodeData.aspectNames.indexOf('rma:ghosted') > -1 ? true : false;


                        // join separated signature data to array of signature objects
                        let epodpisi = null;
                        let steviloEpodpisov = 0;

                        _.each(_this.$store.getters.getAlfrescoDictionary, function(v, k){
                            if(v.name === 'EH:e_podpis') {
                                console.log("v", v);
                                epodpisi = v.properties;
                            }
                        });

                        steviloEpodpisov =  _this.nodeData.properties['EH:stevilo_podpisov'];
                        delete epodpisi['EH:stevilo_podpisov'];


                        for(let i = 0; i < steviloEpodpisov; i++) {
                            let podpis = {};
                            _.forOwn(epodpisi, function (v, k){
                                console.log("k", k, "v", _this.nodeData.properties[k][i]);
                                podpis[k] = _this.nodeData.properties[k][i];
                            });
                            _this.podpisi.push(podpis);
                        }
                        console.log("PODPISI", _this.podpisi);


                        _this.getComponents();
                        _this.getLinksToLeadingDocument();
                        _this.checkIfLongStorageDocumentIsAvailable();

                        _.map(res.data.entry.properties['EH:povezave_na_vodilne_dokumente'], function (val) {
                            _this.getParentDocument(val);
                        });

                        _.map(res.data.entry.properties['EH:komponenta_povezave_na_dokumente'], function (val) {
                            _this.getParentDocumentComponent(val);
                        });

                        if(!_this.deleted) {
                            _this.getFileBlob();
                        }

                        let types = _.filter(_this.$store.getters.getAlfrescoDictionary, function (v, k) {

                            if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 3) === 'EH:') {
                                return true
                            } else {
                                return false
                            }
                        });

                        _this.nodeData.types = types;
                        console.log("types", types);


                        _this.isLoading = false;
                        console.log("node data: ", _this.nodeData);


                        if(!_this.deleted) {
                            if (_this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf' ||
                                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'image' ||
                                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'audio' ||
                                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'video' ||
                                _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'html') {
                                _this.showPreview(false);
                                _this.isLoading = false;
                            } else {
                                _this.getFilePreview();
                                _this.isLoading = false;
                                _this.isLoadingPreview = true;
                            }
                        }

                        _this.$forceUpdate();

                        //console.log(_this.globalFunctions.getFileTypeIcon(_this.nodeData.content.mimeType));

                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });


            },

            displayReadableCodeListValues() {
                const _this = this;

                _.each(_this.allMetadataOptions, function (val, key) {
                    let property = val.property;

                    if (_this.nodeData.properties[property]) {
                        _this.nodeData.properties[property] = _.find(_this.allMetadataOptions[key].body, {id: _this.nodeData.properties[property]}).description;
                    }
                });

            },

            getFileBlob() {
                const _this = this;

                this.isLoading = true;

                let requestUrl = null;
                if(_this.location === 'cache') {
                    requestUrl = _this.host + config.cacheCoreApi + 'nodes/';
                } else {
                    requestUrl = config.alfrescoCoreApi + 'nodes/';
                }

                axios.get(requestUrl + _this.nodeData.id + '/content?attachment=true', {
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                })

                    .then((res) => {

                        console.log("RESPONSE ", res);

                        if(this.showLoadTimes) {
                            _this.axiosData.push({
                                url: res.url,
                                time: res.responseTime
                            });
                        }


                        this.fileBlob = res.data;
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });

            },

            getFilePreview() {
                const _this = this;

                // TODO!!!
                // let requestUrl = null;
                // if(_this.location === 'cache') {
                //     requestUrl = _this.host + config.cacheCoreApi + 'nodes/';
                // } else {
                //     requestUrl = config.alfrescoCoreApi + 'nodes/';
                // }

                axios.get(config.alfrescoThumbnails + '/' + _this.nodeData.id + '/content/thumbnails/pdf?c=force', {
                    method: 'GET',
                })
                    .then((res) => {
                        console.log(res);

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                        _this.fileBlob = res.data;
                        _this.showPreview(true);
                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoadingPreview = false;

                        Vue.$toast.open({
                            message: this.$t('text.documentDetails.documentPreviewNotAvailableToast.message'),
                            type: 'error',
                            position: 'top-right'
                        });

                    });
            },

            showPreview(showFromRenditions) {
                const _this = this;

                let getPdfPreview = "";

                if(_this.location === 'cache') {
                    if (showFromRenditions) {
                        getPdfPreview = _this.host + config.cacheCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/pdf/content?attachment=true&placeholder=false';
                    } else {
                        getPdfPreview = _this.host + config.cacheCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true';
                    }
                } else {
                    if (showFromRenditions) {
                        getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/pdf/content?attachment=true&placeholder=false';
                    } else {
                        getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true';
                    }
                }


                axios.get(getPdfPreview, {
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                })

                    .then((res) => {
                        console.log("RES", res.data);

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                        _this.filePreviewBlob = res.data;
                        _this.isLoading = false;
                        _this.isLoadingPreview = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        _this.isLoading = false;
                    });

            },

            downloadFile() {
                const _this = this;

                this.isLoading = true;

                const url = window.URL.createObjectURL(_this.blobToFile(_this.fileBlob, _this.nodeData.name));
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', _this.nodeData.name);
                link.setAttribute('type', _this.nodeData.content.mimeType);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.isLoading = false;
            },

            blobToFile(theBlob, fileName){
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            },

            // TODO
            getRokHrambeReadableLabel(rokHrambeType) {

                if (rokHrambeType == null) {
                    return null;
                } else {

                    for (let i = 0; i < this.rokHrambe.length; i++) {
                        if (this.rokHrambe[i].type.toString() === rokHrambeType.toString()) {
                            return this.rokHrambe[i].explanation;
                        }

                    }

                    return null;
                }

            },

            getComponents() {
                const _this = this;

                let query = {
                    "query": {
                        "query": "EH:komponenta_povezave_na_dokumente:\"" + _this.nodeData.id + "\""
                    },
                    "include": [
                        "properties"
                    ]
                };

                // TODO!!!
                // let requestUrl = null;
                // if(_this.location === 'cache') {
                //     requestUrl = _this.host + config.cacheCoreApi + 'nodes/';
                // } else {
                //     requestUrl = config.alfrescoCoreApi + 'nodes/';
                // }

                axios.post(config.alfrescoSearchApi, query)
                    .then((res) => {
                        _this.components = res.data.list.entries;

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                    })
                    .catch((error) => {
                        console.log("error", error);
                    });

            },

            getLinksToLeadingDocument() {
                const _this = this;

                let query = {
                    "query": {
                        "query": "EH:povezave_na_vodilne_dokumente:\"" + _this.nodeData.id + "\""
                    },
                    "include": [
                        "properties"
                    ]
                };

                // TODO!!!
                // let requestUrl = null;
                // if(_this.location === 'cache') {
                //     requestUrl = _this.host + config.cacheCoreApi + 'nodes/';
                // } else {
                //     requestUrl = config.alfrescoCoreApi + 'nodes/';
                // }

                axios.post(config.alfrescoSearchApi, query)
                    .then((res) => {
                        _this.linksToLeadingDocument = res.data.list.entries;

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                    })
                    .catch((error) => {
                        console.log("error", error);
                    });

            },

            getParentDocument(parentId) {
                const _this = this;

                let query = { query: {"query":"=ID:\"workspace://SpacesStore/" + parentId + "\" AND TYPE:\"cm:content\" AND ASPECT:\"EH:osnovni_podatki\""} };

                // TODO!!!
                // let requestUrl = null;
                // if(_this.location === 'cache') {
                //     requestUrl = _this.host + config.cacheCoreApi + 'nodes/';
                // } else {
                //     requestUrl = config.alfrescoCoreApi + 'nodes/';
                // }

                axios.post(config.alfrescoSearchApi, query)
                    .then((res) => {
                        console.log("RES -->", res.data.list.entries);

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }


                        if(res.data.list.entries.length > 0) {
                            axios.get(config.alfrescoCoreApi + 'nodes/' + parentId)
                                .then((res) => {

                                    if(this.showLoadTimes) {
                            _this.axiosData.push({
                                url: res.url,
                                time: res.responseTime
                            });
                        }

                                    _this.linksToParentDocument.push(_this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, res.data.entry))
                                })
                                .catch((error) => {
                                    console.error(error);
                                });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            getParentDocumentComponent(parentId) {
                const _this = this;

                let query = { query: {"query":"=ID:\"workspace://SpacesStore/" + parentId + "\" AND TYPE:\"cm:content\" AND ASPECT:\"EH:osnovni_podatki\""} };

                // TODO!!!
                // let requestUrl = null;
                // if(_this.location === 'cache') {
                //     requestUrl = _this.host + config.cacheCoreApi + 'nodes/';
                // } else {
                //     requestUrl = config.alfrescoCoreApi + 'nodes/';
                // }

                axios.post(config.alfrescoSearchApi, query)
                    .then((res) => {
                        console.log("RES -->", res.data.list.entries);
                        if(this.showLoadTimes) {
                            // _this.axiosData.push({
                            //     url: res.url,
                            //     time: res.responseTime
                            // });
                        }

                        if(res.data.list.entries.length > 0) {
                            axios.get(config.alfrescoCoreApi + 'nodes/' + parentId)
                                .then((res) => {

                                    if(this.showLoadTimes) {
                            _this.axiosData.push({
                                url: res.url,
                                time: res.responseTime
                            });
                        }

                                    _this.linksToParentDocumentComponents.push(_this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, res.data.entry))
                                })
                                .catch((error) => {
                                    console.error(error);
                                });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            skipDispositionAction() {
                const _this = this;

                axios.post(config.rootEhramba + 'completeNextDispositionAction?nodeId=' + _this.nodeData.id)
                    .then((res) => {
                        console.log("OK");

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                        Vue.$toast.open({
                            message: this.$t('text.documentDetails.requestSuccessfullySentToast.message'),
                            type: 'success',
                            position: 'top-right'
                        });

                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            refreshDispositionAction() {
                const _this = this;

                axios.post(config.rootEhramba + 'refreshDispositionActions')
                    .then((res) => {
                        console.log("OK");

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                        _this.getNode(_this.nodeData.id);
                    })
                    .catch((error) => {
                        console.error(error);
                    });


            },

            closeModal: function () {
                const _this = this;

                if (_this.$refs['deleteArchivedRecord-modal']) {
                    _this.$refs['deleteArchivedRecord-modal'].hide();
                    _this.deleteArchivedRecordDescription = '';
                }

                if (_this.$refs['changeStorageLocation-modal']) {
                    _this.$refs['changeStorageLocation-modal'].hide();
                    _this.changeStorageLocationNewLocation = null;
                    _this.changeStorageLocationSendDate = null;
                    _this.changeStorageLocationReceieveDate = null;
                }
            },

            beforeDeleteItem() {
                const _this = this;

                let gradivoArhivirano = _this.nodeOriginalData.properties['EH:status_gradiva'] === 3;

                if(gradivoArhivirano) {

                    this.$refs['deleteArchivedRecord-modal'].show();

                } else {

                    this.$swal({
                        title: this.$t('text.globals.warningTitle'),
                        text: this.$t('text.documentDetails.deleteDocumentWarningSwal.prompt') + (_this.nodeData ? _this.nodeData.properties["cm:title"] : "") + "?",
                        dangerMode: true,
                        buttons: {
                            cancel: {
                                text: this.$t('text.globals.cancel'),
                                value: null,
                                visible: true,
                                className: "",
                                closeModal: true,
                            },
                            confirm: {
                                text: this.$t('text.globals.delete'),
                                value: true,
                                visible: true,
                                className: "",
                                closeModal: true
                            }
                        },
                    })
                        .then((value) => {

                            switch (value) {

                                case true:

                                    _this.deleteItem();

                                case null:

                                    return;

                                    break;

                                default:

                            }
                        });

                }


            },

            deleteItem() {
                const _this = this;

                _this.isLoading = true;

                let data = {
                    "nodeIds": [_this.nodeData.id]
                };

                // check for attachments
                axios.post(config.rootEhramba + 'prilogeKomponenteCheck', data)
                    .then((res) => {

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }


                        _this.isLoading = false;


                        if(res.data.length > 0) {

                            swal({
                                title: this.$t('text.documentDetails.selectedDocumentContainsComponentsSwal.title'),
                                type: 'error',
                                text: '',
                                icon: 'warning',
                                dangerMode: true,
                                buttons: {
                                    cancel: {
                                        text: this.$t('text.documentDetails.selectedDocumentContainsComponentsSwal.cancelText'),
                                        value: null,
                                        visible: true,
                                        className: "",
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: this.$t('text.documentDetails.selectedDocumentContainsComponentsSwal.confirmText'),
                                        value: true,
                                        visible: true,
                                        className: "",
                                        closeModal: true
                                    }
                                },
                            })
                                .then((value) => {

                                    switch (value) {

                                        case true:
                                            _this.deleteItemAfterConfirmation();
                                            break;

                                        case null:
                                            break;
                                        default:

                                    }
                                });

                        } else {
                            _this.deleteItemAfterConfirmation();
                        }

                    })
                    .catch((error) => {
                        console.log("error", error);
                        _this.isLoading = false;

                        Vue.$toast.open({
                            message: this.$t('text.documentDetails.errorWhenGettingComponentInfoToast.message'),
                            type: 'error',
                            position: 'top-right'
                        });

                    });



            },

            deleteItemAfterConfirmation() {
                const _this = this;

                console.log("brisanje NEarhiviranega gradiva");
                _this.isLoading = true;

                axios.delete(config.rootEhramba + 'deleteIncompleteNode?nodeId=' + _this.nodeData.id)
                    .then((res) => {
                        console.log("GRADIVO IZBRISANO");
                        _this.isLoading = false;
                        _this.$router.go(-1);
                    })
                    .catch((error) => {
                        _this.isLoading = false;
                        console.error(error);
                    });
            },


            deleteArchivedRecord() {
                const _this = this;

                _this.isLoading = true;

                let data = {
                    "nodeIds": [_this.nodeData.id],
                    "irregularDestroyExplanation": _this.deleteArchivedRecordDescription
                };

                axios.post(config.rootEhramba + 'irregularDestroy', data)
                    .then((res) => {

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                        console.log("res", res);
                        _this.$router.go(-1);
                        console.log("GRADIVO IZBRISANO - TODO: reload z novim podatkov ...");
                        _this.isLoading = false;
                        _this.closeModal();
                    })
                    .catch((error) => {
                        _this.isLoading = false;
                        console.error(error);
                    });

            },

            showChangeStorageLocationModal() {
                const _this = this;

                _this.$refs['changeStorageLocation-modal'].show();
            },

            changeStorageLocation() {
                const _this = this;

                _this.showChangeStorageLocationValidation = false;

                if(_this.changeStorageLocationNewLocation === '' || _this.changeStorageLocationSendDate === null ||  _this.changeStorageLocationReceieveDate === null) {
                    _this.showChangeStorageLocationValidation = true;
                    return;
                }

                _this.isLoading = true;

                let data = {
                    "nodeId": _this.nodeData.id,
                    "properties":
                        {
                            "EH:lokacija_hrambe": _this.changeStorageLocationNewLocation,
                            "EH:datum_posiljanja_gradiva_z_lokacije": _this.changeStorageLocationSendDate,
                            "EH:datum_sprejema_gradiva_na_lokacijo": _this.changeStorageLocationReceieveDate
                        }
                };

                axios.post(config.rootEhramba + 'editClosedRecord', data)
                    .then((res) => {

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                        _this.isLoading = false;
                        _this.closeModal();
                        Vue.$toast.open({
                            message: this.$t('text.documentDetails.storageLocationChangeSuccessfulToast.message'),
                            type: 'success',
                            position: 'top-right'
                        });
                        _this.getNode(_this.nodeData.id);
                        console.log(res);

                    })
                    .catch((error) => {
                        console.error(error);
                        _this.closeModal();
                        _this.isLoading = false;
                        Vue.$toast.open({
                            message: this.$t('text.documentDetails.storageLocationChangeErrorToast.message'),
                            type: 'error',
                            position: 'top-right'
                        });
                    });

            },

            printDocument() {
                const _this = this;

                _this.isLoading = true;

                axios
                    .get(config.reports + 'printDocumentDetails?nodeId=' + _this.nodeData.id, {
                        responseType: "blob"
                    })
                    .then(res => {

                        // if(this.showLoadTimes) {
                        //     _this.axiosData.push({
                        //         url: res.url,
                        //         time: res.responseTime
                        //     });
                        // }

                        const url = window.URL.createObjectURL(
                            _this.blobToFile(res.data, "Metapodatki")
                        );
                        const link = document.createElement("a");

                        link.href = url;
                        link.setAttribute("download", "Metapodatki dokumenta.pdf");
                        link.setAttribute("type", "application/pdf");
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        _this.isLoading = false;
                    })
                    .catch(error => {
                        _this.isLoading = false;
                        console.error(error);
                    });


                // let save = document.createElement('a');
                // save.href = config.rootEhramba + 'printDocumentDetails?nodeId=' + _this.nodeData.id;
                // save.target = '_blank';
                // save.download = 'metapodatki.pdf';

                // let evt = new MouseEvent('click', {
                //     'view': window,
                //     'bubbles': true,
                //     'cancelable': false
                // });
                // save.dispatchEvent(evt);

                // (window.URL || window.webkitURL).revokeObjectURL(save.href);

                // setTimeout(function(){
                //     _this.isLoading = false;
                // }, 300);
            },

            async checkIfLongStorageDocumentIsAvailable() {
                const _this = this;

                axios.get(config.rootEhramba + 'longTermConverted?nodeId=' + _this.nodeData.id)
                    .then((res) => {
                        if(res.data !== null) {
                            _this.longStorageDocumentIsAvailable = true;
                        } else {
                            _this.longStorageDocumentIsAvailable = false;
                        }
                    })
                    .catch((error) => {
                        console.log("error", error);
                        return false
                    });
            }



        }
    };
</script>



// WEBPACK FOOTER //
// src/components/DocumentDetailsComponent.vue